/* eslint-disable react/no-unused-prop-types */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text } from '@mantine/core';
import { FC } from 'react';
import { IconPaperclip, IconX } from '@tabler/icons';
import { TextBlockDto } from '../../Types/DocumentT';
import { useModalState } from '../../Molecules/Dialogs';
import FileSelectDialog from '../../Molecules/Dialogs/FileSelectDialog';
import { openFilePickerModal } from '../../Molecules/Dialogs/FilePickerModal';
import { useJwtClaims } from '../../Service/Context/AuthContext';
import { BookitupEntity } from '../../Service/FileS';

interface Props {
  secondary?: boolean;
  textBlock: TextBlockDto;
  changeBlock: (patch: Partial<TextBlockDto>) => void;
  eventId?: string; 
}

const TextBlockFilePreview: FC<Props> = ({ secondary = false, textBlock, changeBlock, eventId }) => {
  const { imageFileNameFirstColumn, imageEntityIdFirstColumn, imageEntityIdSecondColumn, imageFileNameSecondColumn } =
    textBlock;
  const { show, toggle } = useModalState(false);
  const { profileId } = useJwtClaims();

  const detach = () => {
    if (!secondary) {
      changeBlock({ imageEntityIdFirstColumn: null, imageFileNameFirstColumn: null, imageEntityTypeFirstColumn: null });
    } else {
      changeBlock({
        imageEntityIdSecondColumn: null,
        imageFileNameSecondColumn: null,
        imageEntityTypeSecondColumn: null,
      });
    }
  };

  const patchImage = (entity: BookitupEntity) => {
    const { entityType, entityId, fileName } = entity;
    if (!secondary) {
      changeBlock({
        imageEntityIdFirstColumn: entityId,
        imageFileNameFirstColumn: fileName,
        imageEntityTypeFirstColumn: entityType,
      });
    } else {
      changeBlock({
        imageEntityIdSecondColumn: entityId,
        imageFileNameSecondColumn: fileName,
        imageEntityTypeSecondColumn: entityType,
      });
    }
  };

  if ((!imageEntityIdFirstColumn && !secondary) || (!imageEntityIdSecondColumn && secondary)) {
    return (
      <>
        <Text
          mt={5}
          color="blue"
          variant="link"
          sx={{ cursor: 'pointer' }}
          onClick={() =>
            openFilePickerModal({
              eventId,
              profileId: profileId.toString(),
              onSelect: patchImage,
              allowedExtensions: ['jpg', 'jpeg', 'png', 'svg', 'gif'],
            })
          }
        >
          + Bild hinzufügen
        </Text>
        <FileSelectDialog show={show} toggle={toggle} onFileSelect={patchImage} eventId={undefined} />
      </>
    );
  }
  return (
    <Group
      mt={5}
      position="apart"
      p="xs"
      sx={(theme) => ({
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colors.gray[0],
        maxWidth: 300,
      })}
    >
      <Text className="overflow-ellipsis" weight="bold" color="blue" sx={{ cursor: 'pointer', width: 240 }}>
        <IconPaperclip size={16} /> {!secondary ? imageFileNameFirstColumn : imageFileNameSecondColumn}
      </Text>
      <div>
        <IconX size={16} style={{ cursor: 'pointer' }} onClick={detach} />
      </div>
    </Group>
  );
};

export default TextBlockFilePreview;
